import CartList from "@components/CartList"
import CheckoutButton from "@components/CheckoutButton"
import { Button, ButtonProps } from "../ui/base/button"
import { useSliceContext } from "../SliceProvider"
import { CartRecap, getSliceSubdomain } from "@src/index"
import EmptyCart from "../icons/EmptyCart"

const Checkout = ({
  slicerId,
  buttonLabel,
  buttonProps,
  storeLink,
  onSuccess,
  onError
}: {
  slicerId?: number
  storeLink?: string
  buttonLabel?: string
  buttonProps?: ButtonProps
  onSuccess?: () => void | Promise<void>
  onError?: () => void | Promise<void>
}) => {
  const { cart, appChainId, theme } = useSliceContext()
  const { backgroundColor, textColor } = theme

  if (slicerId == undefined) {
    slicerId = cart?.[0]?.slicerId
  }
  const href =
    storeLink ||
    (slicerId &&
      `https://${getSliceSubdomain(appChainId)}slice.so/slicer/${slicerId}`)

  return cart.length ? (
    <div
      className={`${backgroundColor} ${textColor} sl-space-y-4 sl-max-w-screen-sm sl-mx-auto sl-pb-[192px] sm:sl-pb-0 sm:sl-space-y-8`}
    >
      <div className="sl-mx-4 md:sl-mx-0">
        <CartList />
      </div>
      <div
        className={`${backgroundColor} sl-fixed sl-bottom-0 sl-w-full sl-left-0 sl-z-100 sl-shadow-md sl-shadow-black sl-border-t-[1px] sl-border-muted-foreground/20 sm:sl-static sm:sl-z-0 sm:sl-shadow-none`}
      >
        <div className="sl-px-4 sl-pb-4 sl-pt-2 md:sl-px-0">
          <CartRecap />
          <CheckoutButton
            buttonProps={buttonProps}
            label={buttonLabel}
            onSuccess={onSuccess}
            onError={onError}
          />
        </div>
      </div>
    </div>
  ) : (
    <div
      className={`${backgroundColor} ${textColor} sl-flex sl-flex-col sl-items-center sl-justify-center`}
    >
      <EmptyCart width="50%" height="300px" />
      <div className="sl-mt-8">
        <p className="sl-text-lg">Your cart is empty</p>
        <GoBack href={href} />
      </div>
    </div>
  )
}

const GoBack = ({ href }: { href?: string }) => {
  const { appChainId } = useSliceContext()

  return (
    <div className="sl-mt-4 sl-text-center sl-border sl-border-black sl-rounded-lg">
      <a href={href || `https://${getSliceSubdomain(appChainId)}slice.so`}>
        <Button variant="link">Go back to {href ? "store" : "Slice"}</Button>
      </a>
    </div>
  )
}

export default Checkout
